import { List } from 'components/ui';
import ListItem from 'components/place/index/list_item';
import ListHeader from 'components/place/index/list_header';
import Loader from 'components/loader';


const Index = ({ places, sortBy, onSortChange, loading }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader
        visible={places.places.length > 0}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      {places.places.map((place) => (
        <ListItem key={place.id} place={place} />
      ))}
    </List>
  );
};

export default Index;
